<template>
  <div class="flex flex-wrap mb-4">
    <label
      class="w-1/4"
      :for="name"
    >
      <slot />
    </label>
    <div class="flex-grow">
      <div class="flex">
        <div class="w-1/2">
          <input
            class="rounded shadow w-full text-sm p-2 border border-gray-50 focus:bg-gray-50 focus:border-corepla-dark outline-none"
            :name="name + '_date'"
            type="date"
            :value="date"
            @input="inputDate($event.target.value)"
          >
        </div>
        <div class="w-1/2">
          <input
            class="rounded shadow w-full text-sm p-2 border border-gray-50 focus:bg-gray-50 focus:border-corepla-dark outline-none"
            max="23:59"
            min="00:00"
            :name="name + '_time'"
            pattern="[0-2][0-9]:[0-5][0-9]"
            step="3600"
            type="time"
            :value="time"
            @input="inputTime($event.target.value)"
          >
        </div>
      </div>
      <div class="flex">
        <div class="w-1/2">
          <ErrorRow
            :error-fields="errorFields"
            :name="name"
            :submitted="submitted"
          />
        </div>
        <div class="text-xs text-right whitespace-nowrap w-1/2">
          Fuso orario Roma/Europa
        </div>
      </div>
    </div>
    <ErrorIcon
      :error-fields="errorFields"
      :name="name"
      :submitted="submitted"
    />
  </div>
</template>
  
<script setup>

import moment from 'moment-timezone';
import { ref, watch } from 'vue';

import ErrorIcon from "./ErrorIcon.vue";
import ErrorRow from "./ErrorRow.vue";

const props = defineProps({
  errorFields: {
    type: Object,
    required: true
  },
  submitted: {
    type: Boolean,
    required: true
  },
  name: {
    type: String,
    required: true
  },
  modelValue: {
    type: Number,
    default: null
  }
})

const emit = defineEmits(['update:modelValue'])

const date = ref(null)
const time = ref(null)

if (props.modelValue) {
  const modelDate = moment(props.modelValue).tz('Europe/Rome');
  date.value = modelDate.format('YYYY-MM-DD')
  time.value = modelDate.format('HH:mm')
}

watch(() => props.modelValue, () => {
  const modelDate = moment(props.modelValue).tz('Europe/Rome');

  date.value = modelDate.format('YYYY-MM-DD')
  time.value = modelDate.format('HH:mm')
})

const inputDate = (dateInput) => {
  date.value = dateInput;

  if (time.value) {
    emitValue()
  }
}

const inputTime = (timeInput) => {
  time.value = timeInput;

  if (date.value) {
    emitValue()
  }
}

const emitValue = () => {
  const toEmit = moment(date.value + ' ' + time.value, 'YYYY-MM-DD HH:mm').tz('Europe/Rome');
  emit('update:modelValue', toEmit.valueOf())
}

</script>